// extracted by mini-css-extract-plugin
export default {"table-cell":"nJ0pr","number":"ZW5XW"};